import { ReactElement } from 'react';

import { BoundServiceRemoveCommand } from '@dreryk/egabinet-patient-portal-frontend-api';

import { useCqrsCommand, UseCqrsCommandResult } from '@dreryk/command-query-react-common';
import { dispatchSnackbarPositiveEvent, ModalConfirmButton } from '@dreryk/react-components';

import { boundServiceTranslationKeys } from '../../translations';

type BoundServiceRemoveCommandOptions = {
   boundServiceId: number;
   onSuccess: VoidFunction;
};
const useBoundServiceRemoveCommand = (options: BoundServiceRemoveCommandOptions): UseCqrsCommandResult => {
   return useCqrsCommand(
      () => {
         const command = new BoundServiceRemoveCommand();
         command.id = options.boundServiceId;
         return command;
      },
      {
         onSuccess: () => {
            dispatchSnackbarPositiveEvent(boundServiceTranslationKeys.boundServiceRemoved);
            options.onSuccess();
         },
      }
   );
};

type HealthcareProviderPatientPortalBoundServiceRemoveButtonProps = {
   readonly onSuccess: VoidFunction;
   readonly boundServiceId: number;
};

export const HealthcareProviderPatientPortalBoundServiceRemoveButton = (
   props: HealthcareProviderPatientPortalBoundServiceRemoveButtonProps
): ReactElement => {
   const { executeAsync: removeBoundService } = useBoundServiceRemoveCommand({
      boundServiceId: props.boundServiceId,
      onSuccess: props.onSuccess,
   });
   return <ModalConfirmButton label={boundServiceTranslationKeys.remove} onClick={removeBoundService} />;
};
